// extracted by mini-css-extract-plugin
module.exports = {"close":"ModalConfirmPassword_close__1RE5j"};